// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2aY9a","type":"styles_type__L02Ug","choices":"styles_choices__31icE"};